import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../lib/routes'
import { useLang } from '../lib/useLang'

export default function FinalCTA() {
  const navigate = useNavigate()
  const { t } = useLang()
  const steps = t('lp.finalCta.steps')
  return (
    <section id='start' className='relative overflow-hidden hairline-bottom'>
      <div className='hero-grid opacity-50' aria-hidden='true' />
      <div className='relative mx-auto max-w-5xl px-6 lg:px-10 py-32 md:py-48 text-center'>
        <h2
          data-reveal
          className='headline-display text-4xl md:text-6xl lg:text-[5rem]'
        >
          {t('lp.finalCta.titlePart1')}
          {t('lp.finalCta.titlePart2') && (
            <>
              <br />
              <span className='text-muted'>{t('lp.finalCta.titlePart2')}</span>
            </>
          )}
        </h2>

        <p data-reveal className='mt-8 text-lg md:text-xl text-ink/70 max-w-xl mx-auto'>
          {t('lp.finalCta.sub')}
        </p>

        <div data-reveal className='mt-12 flex flex-wrap justify-center gap-3'>
          <button
            type='button'
            onClick={() => navigate(RoutesEnum.CONTACT)}
            className='btn-primary'
          >
            {t('lp.finalCta.btnPrimary')}
          </button>
        </div>

        {Array.isArray(steps) && steps.length > 0 && (
          <div data-reveal className='mt-10 flex flex-wrap items-center justify-center gap-3 text-[0.85rem] text-muted'>
            {steps.map((s, i) => (
              <span key={i} className='inline-flex items-center gap-3'>
                {i > 0 && <span aria-hidden='true'>→</span>}
                <span className='mono tracking-[0.04em]'>{s}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
